/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ControlCategory10 } from './ControlCategory10';
import {
    ControlCategory10FromJSON,
    ControlCategory10FromJSONTyped,
    ControlCategory10ToJSON,
} from './ControlCategory10';
import type { ControlChatOpsTimeoutVerdict } from './ControlChatOpsTimeoutVerdict';
import {
    ControlChatOpsTimeoutVerdictFromJSON,
    ControlChatOpsTimeoutVerdictFromJSONTyped,
    ControlChatOpsTimeoutVerdictToJSON,
} from './ControlChatOpsTimeoutVerdict';
import type { ControlChatOpsUnsureVerdict } from './ControlChatOpsUnsureVerdict';
import {
    ControlChatOpsUnsureVerdictFromJSON,
    ControlChatOpsUnsureVerdictFromJSONTyped,
    ControlChatOpsUnsureVerdictToJSON,
} from './ControlChatOpsUnsureVerdict';
import type { ControlContainEndpointAction } from './ControlContainEndpointAction';
import {
    ControlContainEndpointActionFromJSON,
    ControlContainEndpointActionFromJSONTyped,
    ControlContainEndpointActionToJSON,
} from './ControlContainEndpointAction';
import type { ControlContainFileAction } from './ControlContainFileAction';
import {
    ControlContainFileActionFromJSON,
    ControlContainFileActionFromJSONTyped,
    ControlContainFileActionToJSON,
} from './ControlContainFileAction';
import type { ControlContainUserAction } from './ControlContainUserAction';
import {
    ControlContainUserActionFromJSON,
    ControlContainUserActionFromJSONTyped,
    ControlContainUserActionToJSON,
} from './ControlContainUserAction';
import type { ControlMonitorFallbackPreset } from './ControlMonitorFallbackPreset';
import {
    ControlMonitorFallbackPresetFromJSON,
    ControlMonitorFallbackPresetFromJSONTyped,
    ControlMonitorFallbackPresetToJSON,
} from './ControlMonitorFallbackPreset';
import type { ControlSeverity9 } from './ControlSeverity9';
import {
    ControlSeverity9FromJSON,
    ControlSeverity9FromJSONTyped,
    ControlSeverity9ToJSON,
} from './ControlSeverity9';
import type { ControlStage } from './ControlStage';
import {
    ControlStageFromJSON,
    ControlStageFromJSONTyped,
    ControlStageToJSON,
} from './ControlStage';
import type { ControlUncontainEndpointAction } from './ControlUncontainEndpointAction';
import {
    ControlUncontainEndpointActionFromJSON,
    ControlUncontainEndpointActionFromJSONTyped,
    ControlUncontainEndpointActionToJSON,
} from './ControlUncontainEndpointAction';
import type { ControlUncontainFileAction } from './ControlUncontainFileAction';
import {
    ControlUncontainFileActionFromJSON,
    ControlUncontainFileActionFromJSONTyped,
    ControlUncontainFileActionToJSON,
} from './ControlUncontainFileAction';
import type { ControlUncontainUserAction } from './ControlUncontainUserAction';
import {
    ControlUncontainUserActionFromJSON,
    ControlUncontainUserActionFromJSONTyped,
    ControlUncontainUserActionToJSON,
} from './ControlUncontainUserAction';
import type { ControlVerdict12 } from './ControlVerdict12';
import {
    ControlVerdict12FromJSON,
    ControlVerdict12FromJSONTyped,
    ControlVerdict12ToJSON,
} from './ControlVerdict12';
import type { ControlWspdRule } from './ControlWspdRule';
import {
    ControlWspdRuleFromJSON,
    ControlWspdRuleFromJSONTyped,
    ControlWspdRuleToJSON,
} from './ControlWspdRule';

/**
 * 
 * @export
 * @interface ControlVerdictRule
 */
export interface ControlVerdictRule {
    /**
     * 
     * @type {ControlCategory10}
     * @memberof ControlVerdictRule
     */
    category: ControlCategory10;
    /**
     * 
     * @type {boolean}
     * @memberof ControlVerdictRule
     */
    chatOps: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ControlVerdictRule
     */
    chatOpsMFA: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ControlVerdictRule
     */
    chatOpsTimeoutMonitor?: boolean;
    /**
     * 
     * @type {ControlChatOpsTimeoutVerdict}
     * @memberof ControlVerdictRule
     */
    chatOpsTimeoutVerdict?: ControlChatOpsTimeoutVerdict;
    /**
     * 
     * @type {ControlChatOpsUnsureVerdict}
     * @memberof ControlVerdictRule
     */
    chatOpsUnsureVerdict: ControlChatOpsUnsureVerdict;
    /**
     * 
     * @type {boolean}
     * @memberof ControlVerdictRule
     */
    close: boolean;
    /**
     * 
     * @type {Array<ControlContainEndpointAction>}
     * @memberof ControlVerdictRule
     */
    containEndpointActions: Array<ControlContainEndpointAction>;
    /**
     * 
     * @type {Array<ControlContainFileAction>}
     * @memberof ControlVerdictRule
     */
    containFileActions: Array<ControlContainFileAction>;
    /**
     * 
     * @type {Array<ControlContainUserAction>}
     * @memberof ControlVerdictRule
     */
    containUserActions: Array<ControlContainUserAction>;
    /**
     * 
     * @type {string}
     * @memberof ControlVerdictRule
     */
    createdAt?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ControlVerdictRule
     */
    _default: boolean;
    /**
     * 
     * @type {string}
     * @memberof ControlVerdictRule
     */
    description: string;
    /**
     * 
     * @type {boolean}
     * @memberof ControlVerdictRule
     */
    disabled: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ControlVerdictRule
     */
    escalate: boolean;
    /**
     * 
     * @type {string}
     * @memberof ControlVerdictRule
     */
    id?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ControlVerdictRule
     */
    ignoresRemediation?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ControlVerdictRule
     */
    managedByParent?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ControlVerdictRule
     */
    managedByWspd: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ControlVerdictRule
     */
    managerChatOps: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ControlVerdictRule
     */
    monitor: boolean;
    /**
     * 
     * @type {ControlMonitorFallbackPreset}
     * @memberof ControlVerdictRule
     */
    monitorFallbackPreset?: ControlMonitorFallbackPreset;
    /**
     * 
     * @type {boolean}
     * @memberof ControlVerdictRule
     */
    retired: boolean;
    /**
     * 
     * @type {ControlSeverity9}
     * @memberof ControlVerdictRule
     */
    severity: ControlSeverity9;
    /**
     * 
     * @type {ControlStage}
     * @memberof ControlVerdictRule
     */
    stage: ControlStage;
    /**
     * 
     * @type {string}
     * @memberof ControlVerdictRule
     */
    teamId?: string;
    /**
     * 
     * @type {Array<ControlUncontainEndpointAction>}
     * @memberof ControlVerdictRule
     */
    uncontainEndpointActions: Array<ControlUncontainEndpointAction>;
    /**
     * 
     * @type {Array<ControlUncontainFileAction>}
     * @memberof ControlVerdictRule
     */
    uncontainFileActions: Array<ControlUncontainFileAction>;
    /**
     * 
     * @type {Array<ControlUncontainUserAction>}
     * @memberof ControlVerdictRule
     */
    uncontainUserActions: Array<ControlUncontainUserAction>;
    /**
     * 
     * @type {string}
     * @memberof ControlVerdictRule
     */
    updatedAt?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ControlVerdictRule
     */
    useSourceSeverity?: boolean;
    /**
     * 
     * @type {ControlVerdict12}
     * @memberof ControlVerdictRule
     */
    verdict?: ControlVerdict12;
    /**
     * 
     * @type {boolean}
     * @memberof ControlVerdictRule
     */
    vipChatOps: boolean;
    /**
     * 
     * @type {ControlWspdRule}
     * @memberof ControlVerdictRule
     */
    wspdRule: ControlWspdRule;
}

/**
 * Check if a given object implements the ControlVerdictRule interface.
 */
export function instanceOfControlVerdictRule(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "category" in value;
    isInstance = isInstance && "chatOps" in value;
    isInstance = isInstance && "chatOpsMFA" in value;
    isInstance = isInstance && "chatOpsUnsureVerdict" in value;
    isInstance = isInstance && "close" in value;
    isInstance = isInstance && "containEndpointActions" in value;
    isInstance = isInstance && "containFileActions" in value;
    isInstance = isInstance && "containUserActions" in value;
    isInstance = isInstance && "_default" in value;
    isInstance = isInstance && "description" in value;
    isInstance = isInstance && "disabled" in value;
    isInstance = isInstance && "escalate" in value;
    isInstance = isInstance && "managedByWspd" in value;
    isInstance = isInstance && "managerChatOps" in value;
    isInstance = isInstance && "monitor" in value;
    isInstance = isInstance && "retired" in value;
    isInstance = isInstance && "severity" in value;
    isInstance = isInstance && "stage" in value;
    isInstance = isInstance && "uncontainEndpointActions" in value;
    isInstance = isInstance && "uncontainFileActions" in value;
    isInstance = isInstance && "uncontainUserActions" in value;
    isInstance = isInstance && "vipChatOps" in value;
    isInstance = isInstance && "wspdRule" in value;

    return isInstance;
}

export function ControlVerdictRuleFromJSON(json: any): ControlVerdictRule {
    return ControlVerdictRuleFromJSONTyped(json, false);
}

export function ControlVerdictRuleFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlVerdictRule {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'category': ControlCategory10FromJSON(json['category']),
        'chatOps': json['chatOps'],
        'chatOpsMFA': json['chatOpsMFA'],
        'chatOpsTimeoutMonitor': !exists(json, 'chatOpsTimeoutMonitor') ? undefined : json['chatOpsTimeoutMonitor'],
        'chatOpsTimeoutVerdict': !exists(json, 'chatOpsTimeoutVerdict') ? undefined : ControlChatOpsTimeoutVerdictFromJSON(json['chatOpsTimeoutVerdict']),
        'chatOpsUnsureVerdict': ControlChatOpsUnsureVerdictFromJSON(json['chatOpsUnsureVerdict']),
        'close': json['close'],
        'containEndpointActions': ((json['containEndpointActions'] as Array<any>).map(ControlContainEndpointActionFromJSON)),
        'containFileActions': ((json['containFileActions'] as Array<any>).map(ControlContainFileActionFromJSON)),
        'containUserActions': ((json['containUserActions'] as Array<any>).map(ControlContainUserActionFromJSON)),
        'createdAt': !exists(json, 'createdAt') ? undefined : json['createdAt'],
        '_default': json['default'],
        'description': json['description'],
        'disabled': json['disabled'],
        'escalate': json['escalate'],
        'id': !exists(json, 'id') ? undefined : json['id'],
        'ignoresRemediation': !exists(json, 'ignoresRemediation') ? undefined : json['ignoresRemediation'],
        'managedByParent': !exists(json, 'managedByParent') ? undefined : json['managedByParent'],
        'managedByWspd': json['managedByWspd'],
        'managerChatOps': json['managerChatOps'],
        'monitor': json['monitor'],
        'monitorFallbackPreset': !exists(json, 'monitorFallbackPreset') ? undefined : ControlMonitorFallbackPresetFromJSON(json['monitorFallbackPreset']),
        'retired': json['retired'],
        'severity': ControlSeverity9FromJSON(json['severity']),
        'stage': ControlStageFromJSON(json['stage']),
        'teamId': !exists(json, 'teamId') ? undefined : json['teamId'],
        'uncontainEndpointActions': ((json['uncontainEndpointActions'] as Array<any>).map(ControlUncontainEndpointActionFromJSON)),
        'uncontainFileActions': ((json['uncontainFileActions'] as Array<any>).map(ControlUncontainFileActionFromJSON)),
        'uncontainUserActions': ((json['uncontainUserActions'] as Array<any>).map(ControlUncontainUserActionFromJSON)),
        'updatedAt': !exists(json, 'updatedAt') ? undefined : json['updatedAt'],
        'useSourceSeverity': !exists(json, 'useSourceSeverity') ? undefined : json['useSourceSeverity'],
        'verdict': !exists(json, 'verdict') ? undefined : ControlVerdict12FromJSON(json['verdict']),
        'vipChatOps': json['vipChatOps'],
        'wspdRule': ControlWspdRuleFromJSON(json['wspdRule']),
    };
}

export function ControlVerdictRuleToJSON(value?: ControlVerdictRule | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'category': ControlCategory10ToJSON(value.category),
        'chatOps': value.chatOps,
        'chatOpsMFA': value.chatOpsMFA,
        'chatOpsTimeoutMonitor': value.chatOpsTimeoutMonitor,
        'chatOpsTimeoutVerdict': ControlChatOpsTimeoutVerdictToJSON(value.chatOpsTimeoutVerdict),
        'chatOpsUnsureVerdict': ControlChatOpsUnsureVerdictToJSON(value.chatOpsUnsureVerdict),
        'close': value.close,
        'containEndpointActions': ((value.containEndpointActions as Array<any>).map(ControlContainEndpointActionToJSON)),
        'containFileActions': ((value.containFileActions as Array<any>).map(ControlContainFileActionToJSON)),
        'containUserActions': ((value.containUserActions as Array<any>).map(ControlContainUserActionToJSON)),
        'createdAt': value.createdAt,
        'default': value._default,
        'description': value.description,
        'disabled': value.disabled,
        'escalate': value.escalate,
        'id': value.id,
        'ignoresRemediation': value.ignoresRemediation,
        'managedByParent': value.managedByParent,
        'managedByWspd': value.managedByWspd,
        'managerChatOps': value.managerChatOps,
        'monitor': value.monitor,
        'monitorFallbackPreset': ControlMonitorFallbackPresetToJSON(value.monitorFallbackPreset),
        'retired': value.retired,
        'severity': ControlSeverity9ToJSON(value.severity),
        'stage': ControlStageToJSON(value.stage),
        'teamId': value.teamId,
        'uncontainEndpointActions': ((value.uncontainEndpointActions as Array<any>).map(ControlUncontainEndpointActionToJSON)),
        'uncontainFileActions': ((value.uncontainFileActions as Array<any>).map(ControlUncontainFileActionToJSON)),
        'uncontainUserActions': ((value.uncontainUserActions as Array<any>).map(ControlUncontainUserActionToJSON)),
        'updatedAt': value.updatedAt,
        'useSourceSeverity': value.useSourceSeverity,
        'verdict': ControlVerdict12ToJSON(value.verdict),
        'vipChatOps': value.vipChatOps,
        'wspdRule': ControlWspdRuleToJSON(value.wspdRule),
    };
}

